module.exports = __webpack_public_path__ + "static/media/logo-wide.d81d20e3.png";